<template>
  <div class="all">
    <SideControls />
    <div class="visualizers" v-if="kanbans && kanbans.length">
      <div>All Kanbans</div>
      <input
        type="text"
        class="search"
        v-model="search"
        placeholder="Search Kanbans..."
      />
      <div
        v-for="(kanban, index) in filteredKanbans"
        :key="index"
        class="visualizerLink"
      >
        <span> {{ index }} </span>
        <router-link :to="`/kanban/${kanban._id}`">{{
          kanban.title ? kanban.title : kanban._id
        }}</router-link>
      </div>
      <button class="action" @click="createNewKanban">+ New Kanban</button>
    </div>
  </div>
</template>

<script>
import { getAllKanbans, createNewKanban } from "./KanbanHelpers";
import SideControls from "../../components/SideControls";

export default {
  name: "AllKanbans",
  async created() {
    this.kanbans = await getAllKanbans();
  },
  data() {
    return {
      kanbans: null,
      search: "",
    };
  },
  computed: {
    filteredKanbans() {
      return this.kanbans.filter((kanban) => {
        if (kanban.title) {
          return kanban.title.toLowerCase().includes(this.search.toLowerCase());
        } else {
          return "";
        }
      });
    },
  },
  components: {
    SideControls,
  },
  methods: {
    async createNewKanban() {
      const kanbanId = await createNewKanban();
      this.$router.push(`/kanban/${kanbanId}`);
    },
  },
};
</script>

<style scoped>
.all {
  display: flex;
  position: relative;
  height: calc(100vh - 36px);
}
.visualizers {
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 450px;
}
.visualizerLink {
  padding: 5px;
  background-color: #f7f7f7;
  margin-bottom: 5px;
  margin-top: 5px;
}

.action {
  cursor: pointer;
  margin-top: 10px;
}
.search {
  margin-bottom: 10px;
  margin-top: 5px;
}
</style>